export default {"src":"/_next/static/media/vrsc.210866b1.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};